import { render, staticRenderFns } from "./VPdfInput.vue?vue&type=template&id=1804b906"
import script from "./VPdfInput.vue?vue&type=script&lang=js"
export * from "./VPdfInput.vue?vue&type=script&lang=js"
import style0 from "./VPdfInput.vue?vue&type=style&index=0&id=1804b906&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports